/**
 * Generato automaticamente.
 * Procedimenti
 */

export type AssegnaParereMassivoTipo =
  typeof AssegnaParereMassivoTipo[keyof typeof AssegnaParereMassivoTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssegnaParereMassivoTipo = {
  PARERE_FAVOREVOLE: 'PARERE_FAVOREVOLE'
} as const;
